import React, { useContext, useEffect, useState, Suspense, lazy } from "react";
import { Route, BrowserRouter as Router, Routes, Navigate } from "react-router-dom";
import { LoginContext } from './context/loginContext.jsx';
import { Handle401Error } from "./utils/handle401Error.jsx";
import Spinner from "./components/spinner.jsx";
import MemberHeader from "./components/Header/memberHeader.jsx";
import { createBrowserHistory } from 'history';
import RegistrationHeader from "./components/Header/registrationHeader.jsx";
const Login = lazy(() => import("./pages/login/login.jsx"));
const AutoLogin = lazy(() => import("./pages/login/autoLogin.jsx"));
const Home = lazy(() => import("./pages/home/home.jsx"));
const PreRegistration = lazy(() => import("./pages/registration/membership.jsx"));
const ForgotPassword = lazy(() => import("./pages/forgotPassword/forgotPassword.jsx"));
const ResetPassword = lazy(() => import("./pages/forgotPassword/resetPassword.jsx"));
const PersonalData = lazy(() => import("./pages/membership/personalData/personalData.jsx"));
const Subscription = lazy(() => import("./pages/membership/subscription.jsx"));
const MessageToGK = lazy(() => import("./pages/membership/messageToGK.jsx"));
const Statistics = lazy(() => import("./pages/membership/statistics.jsx"));
const Suggestions = lazy(() => import("./pages/suggestions/suggestions.jsx"));
const Lastseen = lazy(() => import("./pages/suggestions/lastseen.jsx"));
const Messenger = lazy(() => import("./pages/suggestions/messenger/messenger.jsx"));
const CommunityContacts = lazy(() => import("./pages/suggestions/communityContacts/communityContacts.jsx"));
const CommunityLists = lazy(() => import("./pages/suggestions/communityContacts/communityLists.jsx"));
const Registration = lazy(() => import("./pages/registrationProcess/registration.jsx"));
const MyprofileP = lazy(() => import("./pages/personalDetails/myprofile/profileForPartnership.jsx"));
const MyprofileF = lazy(() => import("./pages/personalDetails/myprofile/profileForFriendship.jsx"));
const SocialEnvironement = lazy(() => import("./pages/personalDetails/socialEnvironement.jsx"));
const ContactList = lazy(() => import("./pages/personalDetails/contactList.jsx"));
const Appearance = lazy(() => import("./pages/personalDetails/appearance.jsx"));
const OverallPersonality = lazy(() => import("./pages/personalDetails/overallPersonality.jsx"));
const Hobbies = lazy(() => import("./pages/personalDetails/hobbies.jsx"));
const SocialEngagement = lazy(() => import("./pages/personalDetails/socialEngagement.jsx"));
const MemberServey = lazy(() => import("./pages/personalDetails/memberServey.jsx"));
const Audios = lazy(() => import("./pages/personalDetails/audios/audios.jsx"));
const GalleriesList = lazy(() => import("./pages/personalDetails/galleriesList.jsx"));
const WhatRUlooking4P = lazy(() => import("./pages/personalDetails/whatRUlooking4P.jsx"));
const ThoughtsOnRelationshipF = lazy(() => import("./pages/personalDetails/thoughtsOnRelationshipF.jsx"));
const AboutYouP = lazy(() => import("./pages/personalDetails/aboutYouP.jsx"));
const WhatRUlooking4F = lazy(() => import("./pages/personalDetails/whatRUlooking4F.jsx"));
const ThoughtsOnRelationshipP = lazy(() => import("./pages/personalDetails/thoughtsOnRelationshipP.jsx"));
const AboutyouF = lazy(() => import("./pages/personalDetails/aboutYouF.jsx"));
const RegionalSearchP = lazy(() => import("./pages/personalDetails/regionalSearchP.jsx"));
const RegionalSearchF = lazy(() => import("./pages/personalDetails/regionalSearchF.jsx"));
const PendingPayment = lazy(() => import("./pages/pendingPayment/PendingPayment.jsx"));
const ProcessPayment = lazy(() => import("./pages/pendingPayment/paymentProgress.jsx"));
const Cancellation = lazy(() => import("./pages/cancellation/cancellation.jsx"));
const NoActiveSubscription = lazy(() => import('./pages/pendingPayment/noActiveSubscription.jsx'));
const MailConfirmation = lazy(() => import('./pages/mailConfirmation/mailConfirmation.jsx'));
const PageNotFound = lazy(() => import("./pages/pageNoFound/PageNotFound.jsx"));

export default function Root(props) {
  const [isLoading, setIsLoading] = useState(true);
  let { loginData: {
    memberDetails,
    accessToken,
  }
  } = useContext(LoginContext)
  const history = createBrowserHistory();

  useEffect(() => {
    if (memberDetails == null && accessToken == null || memberDetails) {
      setIsLoading(false);
    }
  }, [memberDetails]);

  if (isLoading) {
    return <div className="root_loader"><Spinner /></div>;
  }

  return (
    <Router basename="/teilnehmer" history={history} future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <Handle401Error />
      {props?.isTokenExpired || !accessToken || memberDetails?.memberStatus == 'CANCELED' ||
        memberDetails?.memberStatus == 'ADMIN_CANCELED'
        ? " " : <MemberHeader />}
      {memberDetails?.memberStatus == 'REGISTRATION' ? <RegistrationHeader /> : " "}
      <Suspense fallback={<div className="root_loader"><Spinner /></div>}>
        <Routes>
          <Route exact path="/resetPassword" element={<ResetPassword />} />
          <Route exact path="/link" element={<MailConfirmation />} />
          {accessToken ? (
            <>
              {getRouteByMemberStatus(memberDetails)}
              {props?.isTokenExpired ? <>
                <Route path="/" element={<Login />} />
                            <Route exact path="/cancellation" element={<Cancellation />} />
                <Route path="*" element={<Navigate to="/" />} />

              </> : null}
            </>
          ) : (
            <>
              <Route path="/" element={<Login />} />
              <Route path="*" element={<Navigate to="/" />} />
            </>
          )}
          {!memberDetails ? (
            <>
              <Route exact path="/forgetpassword" element={<ForgotPassword />} />
              <Route exact path="/pre-registration" element={<PreRegistration />} />
              <Route exact path="/autoLogin" element={<AutoLogin />} />
            </>
          ) : null}
          {!accessToken ? null
            : (
              <>
                <Route exact path="/forgetpassword" element={<Navigate to="/home" />} />
                <Route exact path="/pre-registration" element={<Navigate to="/home" />} />
                <Route exact path="/autoLogin" element={<Navigate to="/home" />} />
                <Route exact path="/cancellation" element={<Navigate to="/home" />} />
              </>
            )}
          <Route path="*" element={<PageNotFound />} />
        </Routes>
      </Suspense>
    </Router>
  );
};

function getRouteByMemberStatus(memberDetails) {
  if (memberDetails?.memberStatus) {
    switch (memberDetails?.memberStatus) {
      case 'REGISTERED':
      case 'BLOCKED':
      case 'ADMIN_BLOCKED':
        return routeMemberArea(memberDetails);
      case 'REGISTRATION':
        return (
          <>
            <Route exact path="/registration" element={<Registration />} />
            <Route path="*" element={<Navigate to="/registration" />} />
          </>
        );
      case 'CANCELED':
      case 'ADMIN_CANCELED':
        return (
          <>
            <Route exact path="/cancellation" element={<Cancellation />} />
            <Route path="*" element={<Navigate to="/cancellation" />} />
          </>)
      default:
        return <Route path="/" element={<Login />} />;
    }
  }
  return <Route exact path="/" element={<Login />} />;
}

function routeMemberArea(memberDetails) {
  return (
    <>
      <Route path="/" element={<Navigate replace to="/home" />} />
      <Route path="/home" element={<Home />} />
      <Route exact path="/membership/personaldata" element={<PersonalData />} />
      <Route exact path="/membership/subcription" element={<Subscription />} />
      <Route exact path="/membership/message-to-gleichklang" element={<MessageToGK />} />
      <Route exact path="/membership/statistics" element={<Statistics />} />

      <Route exact path="/suggestions/suggestions" element={<Suggestions />} />
      <Route exact path="/suggestions/lastseen" element={<Lastseen />} />
      <Route exact path="/suggestions/community-contacts" element={<CommunityContacts />} />
      <Route exact path="/suggestions/community-contacts/nature" element={<CommunityLists listName="nature" />} />
      <Route exact path="/suggestions/community-contacts/project" element={<CommunityLists listName="project" />} />
      <Route exact path="/suggestions/community-contacts/beruf" element={<CommunityLists listName="beruf" />} />
      <Route exact path="/suggestions/community-contacts/treffen" element={<CommunityLists listName="treffen" />} />

      <Route exact path="/suggestions/messenger" element={<Messenger />} />

      <Route exact path="/personal-details/community-contacts" element={<ContactList />} />
      <Route exact path="/personal-details/social-environement" element={<SocialEnvironement />} />
      <Route exact path="/personal-details/appearance" element={<Appearance />} />
      <Route exact path="/personal-details/overall-personality" element={<OverallPersonality />} />
      <Route exact path="/personal-details/hobbies" element={<Hobbies />} />

      <Route exact path="/personal-details/social-engagement" element={<SocialEngagement />} />
      <Route exact path="/personal-details/member-servey" element={<MemberServey />} />
      <Route exact path="/personal-details/gallery" element={<GalleriesList />} />
      <Route exact path="/personal-details/audios" element={<Audios />} />

      {memberDetails?.partnershipActive && <>
        <Route exact path="/partnership/myprofile" element={<MyprofileP />} />
        <Route exact path="/partnership/what-are-you-looking-for" element={<WhatRUlooking4P />} />
        <Route exact path="/partnership/your-thoughts-on-relationship" element={<ThoughtsOnRelationshipP />} />
        <Route exact path="/partnership/regional-search" element={<RegionalSearchP />} />
        <Route exact path="/partnership/about-you" element={<AboutYouP />} />
      </>
      }

      {memberDetails?.friendshipActive &&
        <>
          <Route exact path="/friendship/myprofile" element={<MyprofileF />} />
          <Route exact path="/friendship/what-are-you-looking-for" element={<WhatRUlooking4F />} />
          <Route exact path="/friendship/your-thoughts-on-relationship" element={<ThoughtsOnRelationshipF />} />
          <Route exact path="/friendship/regional-search" element={<RegionalSearchF />} />
          <Route exact path="/friendship/about-you" element={<AboutyouF />} />
        </>
      }
      <Route exact path="/payment" element={<PendingPayment />} />
      <Route exact path="/process/payment" element={<ProcessPayment />} />
      <Route exact path="/inactive/subscription" element={<NoActiveSubscription />} />
    </>
  )
}